import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatControlsModule } from '../MatControls.module';
import { ClinicalSummaryComponent } from './clinical-summary/clinical-summary.component';
import { ImportCdaXMLComponent } from './import-cda-xml/import-cda-xml.component';
import { GetCCDAMessageComponent } from './get-ccdamessage/get-ccdamessage.component';
import { PatientClinicalDataExportComponent } from './patient-clinical-data-export/patient-clinical-data-export.component';
import { GenarateCCDAComponent } from './genarate-ccda/genarate-ccda.component';
import { DirectMessagesComponent } from '../message/direct-messages/direct-messages.component';
import { MessagesModule } from '../message/messages.module';
import { DataExportRecursiveComponent } from './patient-clinical-data-export/data-export-recursive/data-export-recursive.component';
import { ReviewandFinalizeComponent } from './import-cda-xml/reviewand-finalize/reviewand-finalize.component';

const routes: Routes = [
    { path: 'ClinicalSummary', component: ClinicalSummaryComponent },
    { path: 'ImportCDAXML', component: ImportCdaXMLComponent },
    { path: 'ClinicalDataExport', component: PatientClinicalDataExportComponent },
    { path: 'genarateCCDAReport', component: GenarateCCDAComponent },
]
@NgModule({

    declarations: [
        ClinicalSummaryComponent,
        ImportCdaXMLComponent,
        GetCCDAMessageComponent,
        PatientClinicalDataExportComponent,
        GenarateCCDAComponent,
        DataExportRecursiveComponent,
        ReviewandFinalizeComponent
        // , DirectMessagesComponent
    ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatControlsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        MessagesModule
    ],
    bootstrap: [],

    entryComponents: [
        GetCCDAMessageComponent,
        DataExportRecursiveComponent,
        ReviewandFinalizeComponent
        // , DirectMessagesComponent
    ],
    exports: [
        GetCCDAMessageComponent
        //  , DirectMessagesComponent
    ]
})
export class CCDAModule { }

